import React from "react";

/**
 * NavLetters — splits a string into per-letter spans so CSS `.nav-lift`
 * can animate each letter individually on hover.
 */
export default function NavLetters({ text }) {
  return (
    <span className="nav-lift" aria-hidden="false">
      {Array.from(text).map((ch, i) =>
        ch === " " ? (
          <span key={i} data-space="true">&nbsp;</span>
        ) : (
          <span key={i}>{ch}</span>
        )
      )}
    </span>
  );
}
